module.exports = __webpack_public_path__ + "static/img/beiAn.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beiAn.png
// module id = pE7T
// module chunks = 0 2 3 6 7 8 9 12 14 15 21 25 26 27 29 30 31 35 36 39 40 45